var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _c("div", { staticClass: "row no-gutters" }, [
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-4 col-sm-6" },
              [
                _c("validated-input", {
                  attrs: {
                    label: "Name",
                    name: `name`,
                    validate: "required|max:200",
                  },
                  model: {
                    value: _vm.item.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.item, "name", $$v)
                    },
                    expression: "item.name",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-4 col-sm-6" },
              [
                _c("validated-input", {
                  attrs: {
                    label: "Carrier",
                    name: `carier`,
                    validate: "max:200",
                  },
                  model: {
                    value: _vm.item.carrier,
                    callback: function ($$v) {
                      _vm.$set(_vm.item, "carrier", $$v)
                    },
                    expression: "item.carrier",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-4 col-sm-6" },
              [
                _c("validated-input", {
                  attrs: { label: "Code", name: `code`, validate: "max:200" },
                  model: {
                    value: _vm.item.code,
                    callback: function ($$v) {
                      _vm.$set(_vm.item, "code", $$v)
                    },
                    expression: "item.code",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ]),
    _c(
      "div",
      { staticClass: "d-flex justify-content-between border-top pt-3" },
      [
        _c("div", { staticClass: "flex-grow" }, [
          _vm.error
            ? _c("span", { staticClass: "col-md-12 text-danger" }, [
                _vm._v(_vm._s(_vm.error.message)),
              ])
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "d-flex justify-content-end" },
          [
            _c(
              "b-btn",
              {
                staticClass: "btn btn-light mr-2",
                attrs: { variant: "primary" },
                on: { click: _vm.cancel },
              },
              [_vm._v(" Close ")]
            ),
            _c(
              "b-btn",
              {
                attrs: {
                  variant: "primary",
                  disabled: _vm.errors.any() || _vm.pending,
                },
                on: { click: _vm.submit },
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pending,
                      expression: "pending",
                    },
                  ],
                  staticClass: "far fa-spinner-third fa-spin text-white",
                }),
                _vm._v("\n        Save\n      "),
              ]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }